import { render, staticRenderFns } from "./LeavesCard.vue?vue&type=template&id=6d6f74d9&scoped=true&"
import script from "./LeavesCard.vue?vue&type=script&lang=js&"
export * from "./LeavesCard.vue?vue&type=script&lang=js&"
import style0 from "./LeavesCard.vue?vue&type=style&index=0&id=6d6f74d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6f74d9",
  null
  
)

export default component.exports